'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$75() {
  this.aIN = null;
  this.aIO = false;
}
export { $c_Lpresto_CredentialsView$$anon$75 as $c_Lpresto_CredentialsView$$anon$75 };
$p = $c_Lpresto_CredentialsView$$anon$75.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$75;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$75() {
}
export { $h_Lpresto_CredentialsView$$anon$75 as $h_Lpresto_CredentialsView$$anon$75 };
$h_Lpresto_CredentialsView$$anon$75.prototype = $p;
$p.P = (function() {
  if ((!this.aIO)) {
    this.aIN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aIO = true;
  }
  return this.aIN;
});
var $d_Lpresto_CredentialsView$$anon$75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$75, "presto.CredentialsView$$anon$75", ({
  GE: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_CredentialsView$$anon$75 as $d_Lpresto_CredentialsView$$anon$75 };
//# sourceMappingURL=presto.-Credentials-View$$anon$75.js.map
